import React from "react";
import { Layout as AntdLayout, Menu } from "antd";

const { Footer: AntdFooter } = AntdLayout;
export const Footer: React.FC = () => {
    return (
        <AntdFooter style={{ textAlign: "center" }}>Homework App</AntdFooter>
    );
};
